<template>
  <div class="modal fade show" style="display: block;" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            <i class="fa fa-check-circle text-success me-2"></i>
            Approve Closure Request
          </h5>
          <button type="button" class="btn-close" @click="$emit('close')"></button>
        </div>
        
        <div class="modal-body">
          <!-- Request Summary -->
          <div class="alert alert-info">
            <h6 class="alert-heading mb-2">
              <i class="fa fa-info-circle me-1"></i>
              Request Summary
            </h6>
            <div class="row">
              <div class="col-sm-6">
                <strong>Log Number:</strong><br>
                {{ request.subCategoryLogNo }}
              </div>
              <div class="col-sm-6">
                <strong>SubCategory:</strong><br>
                {{ request.subCategoryId?.name || 'N/A' }}
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-6">
                <strong>Requester:</strong><br>
                {{ request.requestedBy?.name || request.requestedBy?.employeeCode || 'N/A' }}
              </div>
              <div class="col-sm-6">
                <strong>Priority:</strong><br>
                <span 
                  class="badge"
                  :class="getPriorityClass(request.priority)"
                >
                  {{ request.priority?.toUpperCase() || 'MEDIUM' }}
                </span>
                <span v-if="request.isUrgent" class="badge bg-warning ms-1">URGENT</span>
              </div>
            </div>
          </div>
          
          <!-- Approval Confirmation -->
        
          
          <!-- Approval Comments -->
          <div class="mb-3">
            <label for="approvalComments" class="form-label">
              <i class="fa fa-comment me-1"></i>
              Approval Comments <span class="text-muted">(Optional)</span>
            </label>
            <textarea 
              id="approvalComments"
              v-model="approvalComments"
              class="form-control"
              rows="4"
              placeholder="Enter any comments or notes about this approval..."
            ></textarea>
       
          </div>
          
          <!-- Quick Comment Templates -->
         
          
          <!-- Confirmation Checkbox -->
          <div class="form-check mb-3">
            <input 
              class="form-check-input" 
              type="checkbox" 
              id="confirmApproval"
              v-model="confirmApproval"
            >
            <label class="form-check-label fw-bold" for="confirmApproval">
              I confirm that I want to approve this closure request and close the subcategory log
            </label>
          </div>
        </div>
        
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="$emit('close')">
            <i class="fa fa-times me-1"></i>
            Cancel
          </button>
          
          <button 
            type="button" 
            class="btn btn-success" 
            @click="handleApprove"
            :disabled="!confirmApproval || loading"
          >
            <i class="fa fa-spinner fa-spin me-1" v-if="loading"></i>
            <i class="fa fa-check me-1" v-else></i>
            {{ loading ? 'Processing...' : 'Approve Request' }}
          </button>
        </div>
      </div>
    </div>
  </div>
  
  <!-- Modal backdrop -->
  <div class="modal-backdrop fade show"></div>
</template>

<script setup>
import { ref, defineProps, defineEmits } from 'vue';
import { PRIORITY_CONFIG } from '@/services/subcategoryClosureService';

// Props
const props = defineProps({
  request: {
    type: Object,
    required: true
  }
});

// Emits
const emit = defineEmits(['close', 'approve']);

// Reactive data
const approvalComments = ref('');
const confirmApproval = ref(false);
const loading = ref(false);

// Quick comment templates


// Methods
const getPriorityClass = (priority) => {
  return PRIORITY_CONFIG[priority]?.class || PRIORITY_CONFIG.medium.class;
};

const addTemplate = (template) => {
  if (approvalComments.value) {
    approvalComments.value += '\n' + template;
  } else {
    approvalComments.value = template;
  }
};

const handleApprove = async () => {
  if (!confirmApproval.value) {
    return;
  }
  
  loading.value = true;
  try {
    emit('approve', props.request._id, approvalComments.value);
  } finally {
    loading.value = false;
  }
};
</script>

<style scoped>
.modal {
  z-index: 1055;
}

.modal-backdrop {
  z-index: 1050;
}

.alert {
  border-radius: 0.375rem;
}

.alert-info {
  background-color: rgba(13, 202, 240, 0.1);
  border-color: rgba(13, 202, 240, 0.2);
  color: #055160;
}

.alert-warning {
  background-color: rgba(255, 193, 7, 0.1);
  border-color: rgba(255, 193, 7, 0.2);
  color: #664d03;
}

.badge {
  font-size: 0.75rem;
}

.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}

.form-check-input:checked {
  background-color: #3e5fce;
  border-color: #3e5fce;
}

.form-text {
  font-size: 0.875rem;
  color: #6c757d;
}

.fw-bold {
  font-weight: 600;
}

.text-success {
  color: #198754 !important;
}

.text-muted {
  color: #6c757d !important;
}
</style>